import React               from 'react';
import classnames          from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default (props) => {
  return (
    <div className="provide-part">
      <label className="label">
        Would you supply all the parts?
      </label>
      <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio"
         name="part_source" id="part_source_yes"
         value="1"
         checked={props.provideParts === true}
         onChange={e => props.onSupplyParts(true)} />
        <label className="form-check-label" htmlFor="part_source_yes">
          Yes
        </label>
      </div>
      <div className="form-check form-check-inline">
        <input className="form-check-input" type="radio"
         name="part_source" id="part_source_no"
         value="0"
         checked={props.provideParts === false}
         onChange={e => props.onSupplyParts(false)} />
        <label className="form-check-label" htmlFor="part_source_no">
          No <span>(I would like PCB Assembly Express to source all or some of the parts)</span>
        </label>
      </div>
    </div>
  );
};
